import { render, staticRenderFns } from "./approval_detail.vue?vue&type=template&id=191a8d00&scoped=true&"
import script from "./approval_detail.vue?vue&type=script&lang=js&"
export * from "./approval_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191a8d00",
  null
  
)

export default component.exports